import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { SelectionOption } from '../../entity/utility-interfaces';

export class MultiSelectOption {
  id: string = '';
  value: string = '';
}
@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: `./multi-select-dropdown.component.html`,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelectDropdownComponent {
  readonly selectedOption = model<any>();
  readonly data = input<SelectionOption[]>([]);
  readonly selectAll = input(false);
  readonly selectionChange = output<any>();
  readonly placeholder = input<string>();
  readonly className = input<string>();
  readonly width = input<string>();
  readonly height = input<string | undefined>('48');
  readonly disabled = input(false);
  constructor() {
  }

  onTeamsSelectionChange(event: any) {
    this.selectionChange.emit(this.selectedOption());
  }

}
